module.exports = __webpack_public_path__ + "files/9af480089648c9ddd5be5d206bfbb66b.png";